import { GenericImage } from "./GenericImage"
import CoatOfArms from '../images/coat_of_arms.png'
import { useTranslation } from "react-i18next"


export const PermitHeader: React.FC = (props:any) => {

    const {t} = useTranslation()
    const handleClickPrint=()=>{
        props.onPrint()
    }
    return (<div className="mx-auto text-center my-2 border-b-2">
        <GenericImage src={CoatOfArms} height={120} width={120} className="mx-auto my-4"/>
        <h1>REPUBLIQUE DEMOCRATIQUE DU CONGO</h1>
        <h2>OFICE DE GESTION DU FRET MULTIMODAL (OGEFREM)</h2>
        <p>CONTRAT D'ADHESION AUX CONDITIONS D'ACCES AU FRET ROUTIER CONGOLAIS <br />(Congolese Road Cargo Access Permit)</p>
        <p><small>Emis conformément au Décret N°09/63 du 03 Décembre 2009, à l'Arrêt Interministériel N° 08/CAB/VPM/MIN /TC/2019, N° 12/CAB/Min/ECONAT/JKN/2019, N° 63/CAB/MIN.ETAT/COEX/2019 et à l'Arrêté Ministériel N° 6 /CAB/VPM/MIN/TC/2019 du 2 janvier 2019 <br />
            (issued in accordence with Ministerial Order)</small></p>
        <p><small>Emis sans surcharges ni ratures <br />(Issued without alterations or erasures</small>)</p>
        </div>)
}
